import { Button } from '@fluentui/react-components';
import { Home20Regular, QuestionCircle24Regular } from '@fluentui/react-icons';
import { useNavigate, type ErrorComponentProps } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ErrorPage } from './error-page';
import { FullPageState } from './full-page-state';

/** Error component of the root route: the plain error page. */
export function RootError({ error, reset }: ErrorComponentProps) {
  return <ErrorPage error={error} onRetry={reset} />;
}

/** Not-found component of the root route. */
export function NotFound() {
  const { t } = useTranslation('backoffice');
  const navigate = useNavigate();
  return (
    <FullPageState
      icon={<QuestionCircle24Regular />}
      title={t('notFound.title')}
      actions={
        <Button
          appearance="primary"
          icon={<Home20Regular />}
          onClick={() => {
            void navigate({ to: '/' });
          }}
        >
          {t('notFound.home')}
        </Button>
      }
    >
      {t('notFound.body')}
    </FullPageState>
  );
}
